/* unplugin-vue-components disabled */import { render } from "./FooterBar.vue?vue&type=template&id=8eaeab62&scoped=true&ts=true"
import script from "./FooterBar.vue?vue&type=script&lang=ts"
export * from "./FooterBar.vue?vue&type=script&lang=ts"

import "./FooterBar.vue?vue&type=style&index=0&id=8eaeab62&lang=scss&scoped=true"

import exportComponent from "/var/static/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.3.4_vue@3.3.4_webpack@4.46.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8eaeab62"]])

export default __exports__